import { ApplicationRef, inject, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, filter, first, fromEvent, interval, merge, throttleTime } from 'rxjs';

const CHECK_INTERVAL_MS = 5 * 60 * 1000;

// Baking the build-time version into the bundle makes every production build a
// unique service-worker version, so each deploy triggers the update banner.
const BUILD_VERSION = typeof APP_VERSION !== 'undefined' ? APP_VERSION : 'dev';

@Injectable({ providedIn: 'root' })
export class UpdateCheckService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly appRef = inject(ApplicationRef);

  constructor() {
    console.info('Expertteam build:', BUILD_VERSION);
    if (!this.swUpdate.isEnabled) return;

    // Wait until the app is stable before starting the interval: the SW is
    // registered with registerWhenStable, and an interval running from
    // bootstrap would keep the app unstable and delay that registration.
    const appStable$ = this.appRef.isStable.pipe(first(stable => stable));
    const timer$ = interval(CHECK_INTERVAL_MS);
    const tabVisible$ = fromEvent(document, 'visibilitychange').pipe(
      filter(() => document.visibilityState === 'visible')
    );

    concat(appStable$, merge(timer$, tabVisible$).pipe(throttleTime(60_000)))
      .subscribe(() => void this.checkForUpdate());
  }

  private async checkForUpdate(): Promise<void> {
    try {
      await this.swUpdate.checkForUpdate();
    } catch (err) {
      console.error('Controle op nieuwe versie mislukt:', err);
    }
  }
}
